import React from 'react';
import { useImpressionRef } from '@noths/polaris-client-react-hooks';

import * as copy from './copy';
import * as styles from './DeliveryInfo.styles';

const DELIVERY_AREA_VISIBILITY_THRESHOLD = 1;
export interface DeliveryInfoProps {
  deliveryInfo?: string;
  onVisible: () => void;
}

export const DeliveryInfo = ({ deliveryInfo, onVisible }: DeliveryInfoProps) => {
  const deliveryAreaRef = useImpressionRef<HTMLDivElement>(() => onVisible(), {
    threshold: DELIVERY_AREA_VISIBILITY_THRESHOLD,
  });

  if (deliveryInfo) {
    return null;
  }

  return (
    <div ref={deliveryAreaRef}>
      {deliveryInfo && (
        <section>
          <h3 css={styles.heading}>{copy.DELIVERY_INFO}</h3>
          <div
            css={styles.content}
            dangerouslySetInnerHTML={{ __html: deliveryInfo }}
            role="presentation"
          />
        </section>
      )}
    </div>
  );
};
